import { render, staticRenderFns } from "./OtherBenefitsDetails.vue?vue&type=template&id=5a43fd61&scoped=true"
import script from "./OtherBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./OtherBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./OtherBenefitsDetails.vue?vue&type=style&index=0&id=5a43fd61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a43fd61",
  null
  
)

export default component.exports